var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('div', {
    staticClass: "row page-title-header"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "page-header"
  }, [_c('b-breadcrumb', {
    staticClass: "m-0"
  }, [_c('b-breadcrumb-item', {
    attrs: {
      "to": {
        name: 'DashboardHome'
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-home"
  })]), _c('b-breadcrumb-item', {
    attrs: {
      "to": {
        name: 'MainGroupbuyingsList'
      }
    }
  }, [_vm._v("總公司團購管理 ")]), _c('b-breadcrumb-item', {
    attrs: {
      "active": ""
    }
  }, [_vm._v("商品白名單列表")])], 1)], 1)])]), _c('b-card', [_c('div', {
    staticClass: "row d-flex mb-4 mb-xl-2 justify-content-space-between"
  }, [_c('div', {
    staticClass: "col-7 d-flex align-items-center"
  }, [_c('h4', {
    staticClass: "mb-2 mb-xl-0 mr-2 font-weight-bold"
  }, [_vm._v("商品白名單列表")])]), _c('div', {
    staticClass: "\n          col-5\n          d-flex\n          justify-content-end\n          align-items-start align-items-xl-center\n        "
  }, [_c('b-button', {
    staticClass: "flex-shrink-0 mb-2 mb-xl-0 ml-2",
    attrs: {
      "variant": "primary"
    },
    on: {
      "click": _vm.handleCreate
    }
  }, [_c('i', {
    staticClass: "fa fa-plus",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v("上傳商品編號 ")])], 1)]), _c('div', {
    staticClass: "\n        d-flex\n        flex-wrap\n        mb-3\n        justify-content-start justify-content-lg-end\n      "
  }, [_c('div', {
    staticClass: "row-searchbar mb-2 mb-md-0 mr-md-2"
  }, [_c('b-form-input', {
    attrs: {
      "placeholder": _vm.PLACEHOLDER_MAP[_vm.keyword_type]
    },
    on: {
      "keyup": function keyup($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.fetchEventProducts.apply(null, arguments);
      }
    },
    model: {
      value: _vm.query.keyword,
      callback: function callback($$v) {
        _vm.$set(_vm.query, "keyword", $$v);
      },
      expression: "query.keyword"
    }
  })], 1), _c('DateSearchPicker', {
    staticClass: "mr-md-2 mr-0",
    attrs: {
      "disabledEndAtDates": _vm.disabledEndAtDates
    },
    on: {
      "update:disabledEndAtDates": function updateDisabledEndAtDates($event) {
        _vm.disabledEndAtDates = $event;
      },
      "update:disabled-end-at-dates": function updateDisabledEndAtDates($event) {
        _vm.disabledEndAtDates = $event;
      }
    },
    model: {
      value: _vm.query,
      callback: function callback($$v) {
        _vm.query = $$v;
      },
      expression: "query"
    }
  }), _c('b-button', {
    on: {
      "click": _vm.fetchEventProducts
    }
  }, [_c('i', {
    staticClass: "fa fa-search"
  })])], 1), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('b-table', {
    attrs: {
      "striped": "",
      "hover": "",
      "responsive": "",
      "items": _vm.eventProducts,
      "fields": _vm.fields,
      "busy": _vm.isLoading
    },
    scopedSlots: _vm._u([{
      key: "table-busy",
      fn: function fn() {
        return [_c('div', {
          staticClass: "text-center my-2"
        }, [_c('b-spinner', {
          staticClass: "align-middle"
        })], 1)];
      },
      proxy: true
    }, {
      key: "cell(title)",
      fn: function fn(data) {
        return [_c('router-link', {
          attrs: {
            "to": {
              name: 'ProductWhiteListDetail',
              params: {
                event_Product_id: data.item.id
              }
            }
          }
        }, [_c('div', [_vm._v(" " + _vm._s(data.item.product && data.item.product.title) + " ")]), _c('div', {
          staticClass: "mb-1"
        }, [_vm._v(" " + _vm._s(data.item.product && data.item.product.sale_page_code) + " ")])])];
      }
    }, {
      key: "cell(picture)",
      fn: function fn(data) {
        return [data.item.product && data.item.product.images[0] && data.item.product.images[0].pic_url ? _c('b-img-lazy', {
          staticClass: "thumb-image",
          attrs: {
            "src": data.item.product.images[0].pic_url,
            "alt": "商品圖片",
            "width": "50",
            "height": "50"
          }
        }) : _vm._e()];
      }
    }, {
      key: "cell(date)",
      fn: function fn(data) {
        return [_c('div', {
          staticClass: "mb-1"
        }, [_vm._v(" " + _vm._s(_vm.format(new Date(data.item.start_at), "yyyy-MM-dd HH:mm")) + " ~ " + _vm._s(_vm.format(new Date(data.item.end_at), "yyyy-MM-dd HH:mm")) + " ")])];
      }
    }, {
      key: "cell(arrange)",
      fn: function fn(data) {
        return [_c('b-button', {
          staticClass: "ml-2",
          attrs: {
            "variant": "primary",
            "to": {
              name: 'ProductWhiteListDetail',
              params: {
                event_Product_id: data.item.id
              }
            }
          }
        }, [_vm._v("查看 ")]), _c('b-button', {
          staticClass: "ml-2",
          attrs: {
            "variant": "inverse-warning",
            "to": {
              name: 'ProductWhiteListEdit',
              params: {
                event_Product_id: data.item.id
              }
            }
          }
        }, [_vm._v("編輯 ")]), _c('b-button', {
          staticClass: "ml-2",
          attrs: {
            "variant": "inverse-danger"
          },
          on: {
            "click": function click($event) {
              return _vm.handleDelete(data.item.id);
            }
          }
        }, [_vm._v("刪除 ")])];
      }
    }])
  })], 1)]), _c('div', {
    staticClass: "\n        d-flex\n        justify-content-center\n        align-items-center\n        flex-column flex-md-row\n      ",
    staticStyle: {
      "margin-top": "80px"
    }
  }, [_c('b-pagination', {
    staticClass: "separated mb-2 mb-md-0",
    attrs: {
      "total-rows": _vm.total,
      "per-page": _vm.query.per_page,
      "aria-controls": "groupbuyList"
    },
    on: {
      "change": _vm.handleChangePage
    },
    model: {
      value: _vm.query.page,
      callback: function callback($$v) {
        _vm.$set(_vm.query, "page", $$v);
      },
      expression: "query.page"
    }
  }), _c('div', {
    staticClass: "ml-2"
  }, [_vm._v(" 每頁顯示數量 "), _c('b-form-select', {
    staticClass: "ml-2",
    staticStyle: {
      "width": "70px"
    },
    attrs: {
      "options": _vm.perPageOptions
    },
    on: {
      "change": _vm.handleChangePage
    },
    model: {
      value: _vm.query.per_page,
      callback: function callback($$v) {
        _vm.$set(_vm.query, "per_page", $$v);
      },
      expression: "query.per_page"
    }
  })], 1)], 1)])], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }